import {
  Role,
  VisitorGroup,
  VisitorGroupMembership,
  VisitorGroupMembershipInput
} from 'graphql/generated/graphqlTypes';

type UpdateVisitorGroupMembershipWithAdminOptions =
  | {
      shouldBeAdmin: boolean;
      adminGroup: VisitorGroup;
    }
  | {
      shouldBeInstaller: boolean;
      installerGroup: VisitorGroup;
    };

type UpdateVisitorGroupMembershipWithAdminGroupArgs = {
  visitorGroupMembership: VisitorGroupMembershipInput[];
  options: UpdateVisitorGroupMembershipWithAdminOptions;
};

export function updateVisitorGroupMembershipWithAdminGroup({
  visitorGroupMembership,
  options
}: UpdateVisitorGroupMembershipWithAdminGroupArgs) {
  let updatedMembership = [...visitorGroupMembership];
  if (
    'shouldBeAdmin' in options &&
    options.shouldBeAdmin &&
    options.adminGroup &&
    !visitorGroupMembership.some((group) => group.visitorGroupId === options.adminGroup.id)
  ) {
    updatedMembership = [
      ...updatedMembership,
      {
        visitorGroupId: options.adminGroup!.id,
        role: Role.None
      }
    ];
  }
  if (
    'shouldBeAdmin' in options &&
    !options.shouldBeAdmin &&
    options.adminGroup &&
    visitorGroupMembership.some((group) => group.visitorGroupId === options.adminGroup.id)
  ) {
    updatedMembership = updatedMembership.filter((group) => group.visitorGroupId !== options.adminGroup!.id);
  }
  if (
    'shouldBeInstaller' in options &&
    options.shouldBeInstaller &&
    options.installerGroup &&
    !visitorGroupMembership.some((group) => group.visitorGroupId === options.installerGroup!.id)
  ) {
    updatedMembership = [
      ...updatedMembership,
      {
        visitorGroupId: options.installerGroup!.id,
        role: Role.None
      }
    ];
  }
  if (
    'shouldBeInstaller' in options &&
    !options.shouldBeInstaller &&
    options.installerGroup &&
    visitorGroupMembership.some((group) => group.visitorGroupId === options.installerGroup!.id)
  ) {
    updatedMembership = updatedMembership.filter((group) => group.visitorGroupId !== options.installerGroup!.id);
  }
  return updatedMembership;
}

/**
 * Enriches each membership entry with the visitor's existing per-group `role`, so re-saving group
 * selections keeps the previously assigned role. The incoming `expirationDate` is authoritative:
 * it comes from the form (initialised from the existing per-group value) and may intentionally be
 * cleared, so it is never overwritten with the server value here. Newly added groups keep their
 * incoming values.
 */
export function preserveExistingMembershipDetails(
  visitorGroupMembership: VisitorGroupMembershipInput[],
  existingMembership: VisitorGroupMembership[]
): VisitorGroupMembershipInput[] {
  return visitorGroupMembership.map((membership) => {
    const existing = existingMembership.find((group) => group.visitorGroup.id === membership.visitorGroupId);
    if (!existing) return membership;
    return {
      ...membership,
      role: existing.role
    };
  });
}
